import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'

// Regular Pages
import Home from './pages/Home'
import About from './pages/About'
import Services from './pages/Services'
import Packages from './pages/Packages'
import Destination from './pages/Destination'
import Booking from './pages/Booking'
import Team from './pages/Team'
import Testimonial from './pages/Testimonial'
import Error from './pages/Error'
import Contact from './pages/Contact'
import Hotels from './pages/Hotels'
import Voyage from './pages/Voyage'
import VoyageDetails from './pages/VoyageDetails'
import Login from './pages/Login'

// Dashboard Page
import Dashboard from './pages/admin/dashboard'
import Omra from './pages/Omra'
import B2BHomepage from './pages/b2b/b2bHome'
import Sports from './pages/Sport'
import HotelList from './pages/HotelTN'
import VoyageB2B from './pages/b2b/voyageb2b'
import OmraB2B from './pages/b2b/omrab2b'
import SportB2B from './pages/b2b/sportb2b'
import Billets from './pages/Billets'
import CoupeDuMonde from './pages/CoupeDuMonde'
import VoyageALaCarte from './pages/Carte'

function AppContent() {
  const location = useLocation()

  // ✅ Check if current route starts with /dashboard or is /login
const shouldHideHeaderFooter = 
  location.pathname === '/login' || 
  location.pathname.startsWith('/dashboard') ||
  location.pathname.startsWith('/b2b');

  return (
    <div>
      {/* Show Header unless on hidden routes */}
      {!shouldHideHeaderFooter && <Header />}

      <Routes>
        {/* Public Pages */}
        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/services' element={<Services />} />
        <Route path='/packages' element={<Packages />} />
        <Route path='/destination' element={<Destination />} />
        <Route path='/booking' element={<Booking />} />
        <Route path='/team' element={<Team />} />
        <Route path='/testimonial' element={<Testimonial />} />
        <Route path='/error' element={<Error />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/hotels' element={<Hotels />} />
        <Route path='/voyage' element={<Voyage />} />
         <Route path='/voyage/:id' element={<VoyageDetails />} />
         <Route path='/coupe' element={<CoupeDuMonde />} />
            <Route path='/carte' element={<VoyageALaCarte />} />
             <Route path='/omra' element={<Omra />} />
              <Route path='/billets' element={<Billets />} />
  <Route path='/sport' element={<Sports />} />
  <Route path='/hotelstn' element={<HotelList />} />
    <Route path='/b2bOmra' element={<OmraB2B />} />
        <Route path='/b2bVoyage' element={<VoyageB2B />} />
            <Route path='/b2bSport' element={<SportB2B />} />


        {/* Auth & Dashboard - ADD WILDCARD HERE */}
        <Route path='/login' element={<Login />} />
        <Route path='/dashboard/*' element={<Dashboard />} />
          <Route path='/b2b/*' element={<B2BHomepage />} />
      </Routes>

      {/* Show Footer unless on hidden routes */}
      {!shouldHideHeaderFooter && <Footer />}
    </div>
  )
}

export default function App() {
  return <AppContent />
}